import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { toast } from '@repo/design-system/components/ui/toaster';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { useTogglePinFoundMutation } from '@repo/store/maps/api/mapsApi';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectSelectedMarkerId } from '@repo/store/maps/slices/mapData';
import type * as MapLibre from 'maplibre-gl';
import { useCallback, useContext } from 'react';
import { MapContext } from '../game-map/map-context';
export function useChecklistToggle(externalMapId, checkedItems) {
  const $ = _c(12);
  const [togglePinFound] = useTogglePinFoundMutation();
  const analytics = useAnalytics();
  const hostType = useHostType();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const mapContext = useContext(MapContext);
  const selectedMarkerId = useAppSelector(selectSelectedMarkerId);
  let t1;
  if ($[1] !== mapContext?.map || $[2] !== selectedMarkerId) {
    t1 = (markerId, found) => {
      const map = mapContext?.map;
      if (!map) {
        return;
      }
      const apply = sourceName => {
        const source = map.getSource(sourceName) as MapLibre.GeoJSONSource | undefined;
        if (!source) {
          return;
        }
        source.updateData({
          update: [{
            id: markerId,
            addOrUpdateProperties: [{
              key: "found",
              value: found
            }]
          }]
        });
      };
      apply("markers");
      if (selectedMarkerId === markerId) {
        apply("selected-marker");
      }
    };
    $[1] = mapContext?.map;
    $[2] = selectedMarkerId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateMapFoundState = t1;
  let t2;
  if ($[4] !== analytics || $[5] !== checkedItems || $[6] !== externalMapId || $[7] !== hostType || $[8] !== t || $[9] !== togglePinFound || $[10] !== updateMapFoundState) {
    t2 = async itemId => {
      if (!externalMapId) {
        return;
      }
      const currentFoundState = checkedItems.has(itemId);
      const nextFound = !currentFoundState;
      updateMapFoundState(itemId, nextFound);
      try {
        await togglePinFound({
          externalId: externalMapId,
          locationId: itemId,
          isCustomPin: false,
          currentFoundState
        }).unwrap();
        analytics.event("game_map_toggle_location_found", {
          mapId: externalMapId,
          locationId: itemId,
          found: nextFound,
          trigger: "checklist-item",
          platform: hostType
        });
      } catch {
        updateMapFoundState(itemId, currentFoundState);
        toast({
          description: t(_temp),
          variant: "error"
        });
      }
    };
    $[4] = analytics;
    $[5] = checkedItems;
    $[6] = externalMapId;
    $[7] = hostType;
    $[8] = t;
    $[9] = togglePinFound;
    $[10] = updateMapFoundState;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const handleToggleItem = t2;
  return handleToggleItem;
}
function _temp($) {
  return $.checklist_pages.failed_to_update_progress;
}